<template>
  <v-card outlined class="report-section-card mb-3">
    <v-card-text class="pa-4">
      <div>
        <div class="section-title">Product</div>
        <div class="section-subtitle">Product price, reorder, and movement reports</div>
      </div>

      <div class="report-list mt-3">
        <div class="report-item" @click="openReport('list')">
          <div class="report-icon-box"><v-img src="@/assets/Report/barcode.png" /></div>
          <div class="report-item-title">Price List</div>
          <v-icon color="#94a3b8">mdi-chevron-right</v-icon>
        </div>

        <div class="report-item" @click="openReport('notSold')">
          <div class="report-icon-box"><v-img src="@/assets/Report/shopping-bag.png" /></div>
          <div class="report-item-title">Didn't sold for last 60 days</div>
          <v-icon color="#94a3b8">mdi-chevron-right</v-icon>
        </div>

        <div class="report-item disabled-item">
          <div class="report-icon-box"><v-img src="@/assets/Report/refund.png" /></div>
          <div class="report-item-title">Refund By Product</div>
          <v-chip x-small>Coming Soon</v-chip>
        </div>

        <div class="report-item" @click="openReport('reorder')">
          <div class="report-icon-box"><v-img src="@/assets/Report/shopping-bag.png" /></div>
          <div class="report-item-title">Product Reorder Point</div>
          <v-icon color="#94a3b8">mdi-chevron-right</v-icon>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "report-product",

  methods: {
    openReport(link) {
      const routeData = this.$router.resolve({ path: `/reportView/product/${link}` });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped>
.report-section-card { border-radius: 20px; background: #ffffff; }
.section-title { font-size: 18px; font-weight: 800; color: #0f172a; }
.section-subtitle { font-size: 13px; color: #64748b; margin-top: 2px; }
.report-list { display: grid; gap: 8px; }
.report-item { display: flex; align-items: center; gap: 12px; padding: 12px; border-radius: 16px; background: #f8fafc; cursor: pointer; transition: 0.2s ease; }
.report-item:hover { background: #eef2ff; }
.report-icon-box { width: 38px; height: 38px; min-width: 38px; border-radius: 12px; background: #ffffff; padding: 7px; display: flex; align-items: center; justify-content: center; }
.report-item-title { flex: 1; font-size: 14px; font-weight: 700; color: #0f172a; }
.disabled-item { cursor: default; opacity: 0.65; }
.disabled-item:hover { background: #f8fafc; }
</style>
